import { RequestStatus } from "../../../request";
import { OverviewReport } from "./reducer";

export const FetchOverviewReport = (
  from: Date,
  until: Date,
  biddingType: "all" | "cpi" | "roas_cpi"
) => {
  return {
    type: "overview-request-report",
    from: from,
    until: until,
    biddingType,
  };
};

export const UpdateCampaignStatusAction = (id: string, isActive: boolean) => {
  return {
    type: "overview-update-campaign-status",
    id: id,
    isActive: isActive,
  };
};

export const UpdateCampaignStatusStateAction = (
  id: string,
  isActive: boolean
) => {
  return {
    type: "overview-deactivate-campaign",
    id: id,
    isActive: isActive,
  };
};

export const UpdateOverviewRequestStateAction = (
  requestState: RequestStatus
) => {
  return {
    type: "overview-update-request-state",
    requestState: requestState,
  };
};

export const UpdateOverviewReport = (report: OverviewReport) => {
  return {
    type: "overview-update-report",
    report: report,
  };
};

export const UpdateOverviewDateRanges = (startDate: Date, endDate: Date) => {
  return {
    type: "overview-update-date-ranges",
    startDate: startDate,
    endDate: endDate,
  };
};

export const UpdateCampaignAfterSuggestionApplied = (
  campaignId: string,
  updatedValues: {
    bid?: number;
    dailyBudgetCap?: number;
    suggestions?: any[];
  }
) => {
  return {
    type: "overview-update-campaign-after-suggestion",
    campaignId,
    updatedValues,
  };
};
